<app-header 
	[icon]="contentType === 'blog' ? 'document-text-outline' : 'book-outline'" 
	[title]="content()?.metadata?.title || 'Loading...'"
	[translateTitle]="false">
</app-header>

<ion-content>
	@if (loading) {
		<div class="loading-container">
			<ion-spinner></ion-spinner>
			<p>Loading content...</p>
		</div>
	} @else if (error) {
		<div class="error-container">
			<p>Error loading content. Please try again later.</p>
		</div>
	} @else {
		<div class="content-navigation">
			<nav class="content-breadcrumb" aria-label="Fil d'Ariane">
				<a [routerLink]="translateService.localize('/')">Home</a>
				<span class="separator">></span>
				<a [routerLink]="translateService.localize(getSectionRoute())">{{ getSectionLabel() }}</a>
				<span class="separator">></span>
				<a [routerLink]="translateService.localize(getCurrentRoute())">{{ getCurrentLabel() }}</a>
			</nav>

			<ion-button [routerLink]="translateService.localize(backRoute || '/')" fill="clear" size="small">
				{{ backLabel }}
			</ion-button>
			<ion-button fill="outline" size="small" color="primary" (click)="shareContent()">
				<ion-icon slot="start" name="share-outline"></ion-icon>
				Partager
			</ion-button>
		</div>
		
		<article class="markdown-content">
			@if (content(); as content) {
				@if (content.metadata?.date || content.metadata?.category) {
					<header class="content-header">
						@if (content.metadata?.category) {
							<div class="content-meta">
								<span class="content-category">{{ content.metadata?.category }}</span>
							</div>
						}
						@if (content.metadata?.date) {
							<p class="content-date">Publié le {{ content.metadata?.date }}</p>
						}
					</header>
				}
				
				<div class="content-body" [innerHTML]="content.html"></div>
				
				@if (content.metadata?.keywords) {
					<footer class="content-footer">
						<p class="content-tags">
							<strong>Mots-clés :</strong> {{ content.metadata?.keywords }}
						</p>
					</footer>
				}
			}
		</article>
	}
</ion-content>
